export default {
	about: 'Conócenos',
	about_the_program: 'Acerca del Programa',
	acc_score: 'Puntaje acumulado',
	accept: 'Aceptar',
	activities: 'Actividades',
	activity: 'Actividad',
	add_a_review: 'Agrega una reseña',
	add_image: 'Añadir imagen',
	address: 'Dirección',
	address_required: 'Dirección requerida',
	all: 'Todos',
	all_f: 'Todas',
	an_error_has_occurred: 'Ocurrió un error',
	an_unexpected_error_has_occurred_try_again:
		'Ha ocurrido un error inesperado. Inténtalo de nuevo.',
	and: 'y',
	answer: 'Respuesta',
	answer_plural: 'Respuestas',
	answer_reported_successfully: 'Respuesta reportada exitosamente',
	answered: 'Contestado',
	apply: 'Aplicar',
	approved: 'Aprobado',
	areas: 'Areas',
	at: 'a',
	attention: 'Atención',
	audio: 'Audio',
	available_in: 'Disponible en',
	back: 'Volver',
	back_to_training: 'Volver a la formación',
	badge: 'Medalla | Medallas',
	badges: 'Medallas',
	before_starting_this: ' antes de comenzar esto',
	bookmarks: 'Favoritos',
	browser_window_blocked_click: 'Su navegador bloqueó la ventana, haga clic en',
	by: 'por',
	calendar: 'Agenda',
	campaign: 'Campaña',
	campaigns: 'Campañas',
	cancel: 'Cancelar',
	cant_watch_click_here: 'Haga clic aquí para ver en pantalla completa',
	categories: 'Categorías',
	category: 'Área de entrenamiento',
	certificate: 'Certificado | Certificados',
	certificates: 'Certificados',
	check_scorm_finished: 'Verificar la finalización de la actividad',
	clear_date: 'Borrar fecha',
	clear_filters: 'Borrar filtros',
	clear_notifications: 'Borrar notificaciones',
	click_here: 'Haga clic aquí.',
	close: 'Cerrar',
	code: 'Código',
	code_a_z: 'Código A-Z',
	compressed_file: 'Archivo Comprimido',
	confirm: 'Confirmar',
	confirm_report_answer: 'Confirmar informe de respuesta',
	confirm_report_topic: 'Confirmar informe de tema',
	confirm_reporting_this_answer_this_should_be_done_only_with_answers_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		'Confirmar para informar esta respuesta? Esto solo debe hacerse con respuestas que no sigan las reglas de la plataforma. Se enviará un mensaje a los moderadores',
	confirm_reporting_this_topic_this_should_be_done_only_with_topics_that_do_not_follow_the_rules_of_the_platform_a_message_will_be_sent_to_moderators:
		'Confirmar informar sobre este tema? Esto debe hacerse solo con temas que no siguen las reglas de la plataforma. Se enviará un mensaje a los moderadores',
	contact_us: 'Contáctanos',
	content: 'Contenido | Contenidos',
	content_deadline: 'Fecha límite para el acceso al contenido',
	cookies_custom: 'Cookies personalizado',
	cookies_custom_information:
		'Cuando accede a esta plataforma, se pueden recopilar cookies y ciertos datos relacionados con su dispositivo para que podamos brindarle contenido y capacitaciones personalizados.',
	cookies_fonctionnels: 'Cookies funcionales',
	cookies_fonctionnels_information:
		'Se utilizan para reconocerte cuando usted accedes a la plataforma, guardar tus preferencias de configuración y proteger a tu usuario. No se pueden desactivar porque son imprescindibles para el funcionamiento de la plataforma.',
	cookies_policy: 'Política de cookies',
	cookies_policy_information:
		'Esta plataforma utiliza cookies para garantizar un servicio más eficaz y personalizado. Al aceptar, estás de acuerdo con su uso.',
	cookies_settings: 'Configuración de cookies',
	copyright: 'Copyright',
	correct: 'Correctas',
	country_of_residence: 'País de residencia',
	country_you_want_to_access: 'País al que desea acceder',
	course: 'Entrenamiento',
	course_price: 'Precio',
	creation_date: 'Fecha de creación',
	creator: 'Creador',
	crop: 'Recortar',
	crop_image: 'Recortar imagen',
	date: 'Fecha',
	description: 'Descripción',
	divorced: 'Divorciado(a)',
	document: 'Documento',
	done: 'Terminado | Terminados',
	doubts_about_training: 'Dudas sobre el entrenamiento',
	download: 'Descarga',
	share: 'Compartir',
	download_app: 'Descargar app',
	download_our_app: 'Descarga nuestra aplicación',
	download_our_app_information:
		'¿Ya conoces nuestra app? Disfruta de nuestro contenido también desde tu iPhone o Android. ¡Descárgala ahora, es gratis!',
	downloading_content: 'Descargando contenido',
	downloads: 'Descargas',
	duration: 'Duración',
	earn_points: 'Gana Puntos',
	earned_points: 'Puntos Ganados',
	earning_points: 'Ganar puntos',
	email: 'Correo',
	enter: 'Acceder',
	error_loading_data: 'Lo siento, hubo un error durante la carga.',
	error_loading_data: 'Hubo un error al cargar la información. Vuelva a intentarlo más tarde.',
	events: 'Mis Eventos',
	excel_file: 'Archivo Excel',
	extensions: 'Extensiones',
	faq: 'FAQ',
	favorite_course: 'Curso Favorito',
	favorite_trail: 'Módulo Favorito',
	featured_rewards: 'Premios destacados',
	file: 'Archivo',
	file_download_failed: 'Descarga de archivo fallida',
	file_download_finished: 'Descarga de archivos finalizada',
	file_download_started: 'Descarga de archivo iniciada',
	filters: 'Filtros',
	filter_category: 'Filtrar por categoría',
	filter_sort_by: 'Ordenar por',
	finished: 'Terminados | Terminados',
	follower: 'Seguidor',
	free: 'grátis',
	frequently_asked_questions: 'Preguntas Frecuentes',
	full_name: 'Nombre completo',
	go_to_class: 'Ir a clase',
	groups: 'Grupos',
	have_any_doubt_sugestion_comment_or_compliment_about_the_intel_rewards_you_program_send_us_a_message:
		'¿Tienes alguna duda, sugerencia, comentario o cumplido sobre el Programa Intel Te Premia? Envíanos un mensaje.',
	headquarter: 'Cadena / Empresa',
	headquarters: 'Cadenas / Empresas',
	help: 'Ayuda',
	helper_new_password: 'Su contraseña debe contener un mínimo de 6 caracteres',
	helper_password_low: 'Su contraseña debe contener al menos 6 caracteres',
	helper_password_medium:
		'Su contraseña debe contener al menos 6 caracteres, letras mayúsculas, letras minúsculas, números',
	helper_password_strong:
		'Su contraseña debe contener al menos 6 caracteres, letras mayúsculas, letras minúsculas, números y símbolos (! @ # $% ˆ)',
	here: 'aqui',
	home: 'Inicio',
	hour: 'hora',
	hour_plural: 'horas',
	how_do_you_rate_this_training: '¿Cómo evalúa esta formación?',
	image: 'Imagen',
	image_from_device: 'Imagen del dispositivo',
	image_from_url: 'Imagen de la dirección',
	image_size: 'Tamaño de la imagen',
	image_url: 'Dirección de imagen',
	in_progress: 'En progreso',
	influencer: 'Influencer',
	insert_sales: 'Incluir Ventas',
	instructors: 'Equipo',
	intel_lovers: 'Intel Lovers',
	introduction: 'Introducción',
	invalid_document: 'Documento inválido',
	invited: 'Invitado',
	items_per_page: 'Ítems por página',
	itp_points: 'Puntos Intel Te Premia',
	joined_the_class: 'se unió a la clase',
	keep_watching: 'Continuá viendo',
	know_more: 'Conócenos',
	language: 'Idioma',
	last: 'Más reciente',
	last_name: 'Apellido',
	legal_information: 'Información Legal',
	lets_talk_about_privacy: '¡Hablemos de privacidad!',
	level: 'Nivel',
	library: 'Biblioteca',
	like: 'Me gusta',
	liked: 'Gustar',
	likes: 'Gustos',
	live_class: 'Clase en Vivo',
	live_classes: 'Clases en Vivo',
	loading_data: 'Cargando datos',
	loading_news: 'Cargando noticias',
	make_sure_all_mandatory_fields_are_completed:
		'Asegúrese de que todos los campos obligatorios estén completos',
	make_sure_that_all_fields_are_filled_in: 'Asegúrarse de que todos los campos estén llenados',
	married: 'Casado(a)',
	meet_the_team: 'Conocer al equipo',
	message: 'Mensaje',
	message_sent_successfully: 'Mensaje enviado correctamente',
	minute: 'minuto',
	minute_plural: 'minutos',
	name: 'Nombre',
	new_certificate_in_course: 'Nuevo certificado en el curso {title}',
	new_certificate_in_trail: 'Nuevo certificado en el modulo {title}',
	new_download_code: 'Nuevo código de download',
	news: 'Novedades',
	next_activity: 'Siguiente actividad',
	no: 'No',
	no_data_avaliable: 'Sin datos',
	no_news_are_available_at_the_moment: 'No hay novedades en el momento.',
	no_news_are_available_with_the_selected_filter:
		'No hay noticias disponibles para el filtro seleccionado',
	no_pre_visualization_available: 'No hay visualización previa disponible',
	no_results: 'Ningún resultado',
	no_results_found: 'Ningún resultado encontrado',
	no_vacancy: 'Agotado',
	not_allowed_or_page_not_found: 'No encontrado o no tengo permiso para acceder.',
	not_answered: 'Sin respuesta',
	not_answered_f: 'Sin respuesta',
	notification: 'Notificación',
	notifications: 'Notificaciones',
	number_required: 'Número requerido',
	neighborhood_required: 'Barrio requerido',
	state_required: 'Estado requerido',
	city_required: 'Ciudad requerida',
	zip_code_required: 'Código postal requerido',
	complete_your_registration: 'Completa tu registro',
	select_your_profile: 'Selecciona tu perfil',
	fill_in_later: 'Completar más tarde',
	document_required: 'Documento es obligatorio',
	document_already_registered: 'Documento ya registrado',
	no_registered_profile: 'No hay perfil registrado. Consulte con el administrador de la plataforma para liberar la autenticación correctamente.',
	login_with_google: 'Iniciar con Google',
	error_signing_in_with_google: 'Error al iniciar sesión con Google. Inténtalo de nuevo más tarde.',
	birthday_must_be_before_today: 'Rellene el campo correctamente',
	please_fill_out_the_form_correctly: 'Por favor, complete el formulario correctamente.',
	your_accounts_has_been_completed_successfully: 'Tu cuenta ha sido completada con éxito',
	register_not_unique: 'registro no único',
	of: 'de',
	online_courses: 'Cursos Online',
	only_available_when_finished_training: 'Disponible solo después de completar la capacitación',
	order_by: 'Ordenar por',
	origin: 'Origen',
	password: 'Contraseña',
	pdf_file: 'Archivo PDF',
	percentage: 'Porcentaje',
	place: 'Lugar',
	platform_meta_description: 'Powered by Take 5 LMS',
	please_wait_activities_loading: 'Cargando actividades, por favor espere...',
	podcasts: 'Podcasts',
	point: 'Punto',
	point_plural: 'Puntos',
	points: 'Puntos',
	points_earned: 'Puntos Ganados',
	points_table: 'Tabla de Puntos',
	pontuation: 'Puntaje',
	post_a_comment: 'Deja un comentario',
	powerpoint_file: 'Archivo PowePoint',
	presential: 'Presencial',
	presential_courses: 'Entrenamientos Presenciales',
	privacy_policy: 'Política de Privacidad',
	price: 'Precio',
	profile: 'Perfil',
	progress: 'Progreso',
	ranking: 'Ranking',
	reaction_evaluation: 'Evaluación de la Reacción',
	received_a_certificate_in_course: '{name} recibió un certificado en el curso {title}',
	received_a_certificate_in_trail: '{name} recibió un certificado en el módulo {title}',
	redemption_code: 'Código de canje',
	refuse: 'Negar',
	regionals: 'Regionales',
	registered: 'Matriculado',
	reproved: 'Reprobado',
	requirement: 'Requisito',
	response_sent_successfully: 'Respuesta enviada exitosamente',
	result_found: 'resultado encontrado | resultados encontrados',
	retry_test: 'Inténtalo de nuevo',
	return_to_activities: 'Volver a las actividades',
	reviews: 'Reseñas',
	reward_store: 'Tienda de Recompensas',
	reward_redemption: 'Rescate de recompensa',
	rewards_you: 'Te Premia',
	rotate_device_for_better_experience: '¡Voltea tu dispositivo para una mejor experiencia!',
	save: 'Grabar',
	save_data_success: '¡Datos guardados con éxito!',
	score: 'Puntaje | Puntos',
	score_statement: 'Extracto de Puntos',
	scorm_finished: 'Actividade terminado',
	scorm_not_finished: 'Actividade no terminado',
	search: 'Buscar',
	search_for_your_address: 'Busca tu dirección',
	search_for_zip_address_or_city: 'Busca por tu código postal, dirección o ciudad',
	see_all_content: 'Ver todo el contenido',
	see_more: 'Ver más',
	select_a_file: 'Selecciona un archivo',
	select_a_image: 'Selecciona una imagen',
	selected_campaign: 'Campaña Seleccionada',
	seller_cant_find_your_store: 'Comerciante/Vendedor(a), ¿no puede encontrar su comercio?',
	seller_hint:
		'Search for your store by simply typing the company registration number (without using dots, dashes or slashes).',
	send: 'Enviar',
	set_cookies: 'Establecer cookies',
	show_certificate: 'Ver Certificado',
	single: 'Soltero(a)',
	size: 'Tamaño',
	start_reaction_assessment: 'Iniciar evaluación de reacción',
	status: 'Estatus',
	support: 'Soporte',
	tags: 'Destacados',
	take_course: 'Toma Curso',
	terms_and_conditions: 'Términos y Condiciones',
	test: 'Prueba',
	there_are_no_codes_available:
		'No hay códigos disponibles para liberar una aplicación en la App Store. Comuníquese con el soporte.',
	this_content_will_be_available_on: 'Este contenido estará disponible en',
	this_website_is_best_viewed_in_google_chrome_and_mozilla_firefox:
		'Este sitio se ve mejor en Google Chrome y Mozilla Firefox',
	timezone: 'Huso horario',
	title: 'Título',
	title_a_z: 'Título A-Z',
	to_access_the_class: 'para acceder a la clase',
	to_do: 'Qué hacer',
	to_understand_why_we_use_cookies: 'Para más información, haga clic aquí.',
	total_results: 'Total de resultados',
	topic_reported_successfully: 'Tema informado con éxito',
	trail: 'Plan de Entrenamiento',
	trail_plural: 'Módulos de Capacitación',
	trails: 'Módulos de Capacitación',
	training: 'Entrenamiento',
	training_plural: 'Entrenamientos',
	type: 'Tipo',
	type_to_search: 'Escribe para buscar',
	unfavorite_course: 'Curso Desfavorito',
	unfavorite_trail: 'Módulo Desfavorito',
	unlike: 'Disgusto',
	upload_photos: 'Enviar fotos',
	user: 'Usuario',
	user_environment: 'Entorno de usuario',
	vimeo: 'Vimeo',
	we_were_unable_to_send_your_message_please_try_again_later:
		'No pudimos enviar tu mensaje, vuelve a intentarlo más tarde',
	webcast: 'Webinar',
	webcasts: 'Webinars',
	webinar: 'Webinars',
	webinars: 'Webinars',
	widowed: 'Viudo(a)',
	window_blocked: 'Ventana bloqueada',
	workload: 'Carga horaria',
	wowza: 'Wowza',
	yes: 'Si',
	you_already_reviewed: 'Ya agregaste una reseña',
	you_must_complete_all_required_training_before_redeeming:
		'Debes completar toda la capacitación requerida antes de canjear',
	you_must_finish_the_test: 'Por favor complete la prueba',
	you_need_to_end_the_training_before_you_can_respond_to_the_reaction_assessment:
		'Debe finalizar la capacitación antes de poder responder a la evaluación de la reacción.',
	you_need_to_finish_the_content: 'Necesitas finalizar el contenido ',
	your_answer: 'Su respuesta',
	your_rating: 'Tu clasificación',
	your_text_is_longer_than_256_characters: 'Su texto tiene más de 256 caracteres.',
	youtube: 'YouTube',
	zip_code: 'Código postal',
	oldest: 'más antíguos',
	correct_answer: 'Pregunta correcta',
	incorrect_answer: 'Pregunta incorrecta',
	drills: 'Drills',
	badge_title_shared: 'Mira la nueva medalla que gané',
	badge_title_earned: '¡Felicitaciones, has ganado una nueva medalla!',
	badge_button_text_claim: 'Aceptar medalla',
	challenge_of_the_day: 'Desafío diario',
	recall_and_test_your_knowledge_with_quick_questions: 'Refresca y prueba tus conocimientos con {count} pregunta rápida | Refresca y prueba tus conocimientos con {count} preguntas rápidas',
	correct_answer: 'Respuesta correcta',
	incorrect_answer: 'Respuesta incorrecta',
	can_you_answer_this_question: '¿eres capaz de responder esta pregunta?',
	unavailable: "Indisponible",
	you_already_have_a_certificate_in_one_event_on_this_catalog: "Ya está inscrito o tiene un certificado en un evento de este catálogo {catalog}.",
	no_category: 'Sin categoría',
	no_access_to_send_points: "Lamentablemente, no tienes permiso para enviar puntos. Por favor, contacta al administrador de la plataforma.",
	search_by_ia: 'Busque IA',
	please_log_in_to_the_platform_first: "Para descargar la aplicación, primero inicie sesión en la plataforma"
}
